import React, {useState} from "react";
import { compose } from "recompose";
import { Table } from "reactstrap";
import { TableContainer, withTable } from "components/common/Tables";
import { Page } from "components/common";
import { Link } from "react-router-dom";
import { XeroTableDataFetch } from "components";
import { Trans } from "react-i18next";

import { useQuery } from "react-query";
import { useXeroClient } from "../../../hooks";
import { NotificationManager } from "react-notifications";
import { useAccounts } from "../../../queries";
import { Button } from "reactstrap";
import useModal from "../../../hooks/useModal";
import EditAccount from "../Settings/ChartOfAccounts";
import BackButton from "components/refactoring/BackButton";
import LoadingMsg from "components/common/LoadingMsg";
import { CurrencySymbol } from "services/util";

const filters = { raw: `Type=="BANK"`, Type: "BANK" };
const emptyArray = [];

export const OrganisationList = ({
  selected,
  match,
  url = "accounts",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  refreshToken,
  refreshData,
  accountTypes,
  t,
  taxRates,

}) => {
  const xero = useXeroClient();
  const [editing, setEditing] = useState();
  const { Modal, setIsOpen, isOpen, toggle } = useModal();
  const { data: currencies } = useQuery(
    "currencies",
    () => {
      const currencies = xero.get("currencies").get("data");
      return currencies.map((i) => ({value: i.Code, label: <CurrencySymbol currency={i.Code} />}));
    },
    {
      placeholderData: emptyArray,
    }
  );

  async function onSuccess() {
    NotificationManager.success(t("Account saved successfully"));
    setIsOpen(false);
    refreshData();
  }

  const [search, setSearch] = useState('');

  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  const filteredResults = data.results.filter(account => {
    const nameCondition = search ? account.Name.toLowerCase().includes(search.toLowerCase()) : true;
    const numberCondition = search ? account.BankAccountNumber.includes(search) : true;
  
    return nameCondition || numberCondition;
  });

  return (
    
  <Page title="Bank Accounts" className="inv-table">
    <BackButton/>
    <div className="d-flex justify-content-between align-items-center mb-4">
      <input
        className="form-control"
        placeholder={t("Search...")}
        type="text"
        id="searchInput"
        value={search}
        onChange={handleInputChange}
      />
      <Button
        color="primary"
        onClick={() => {
          setEditing({
            Code: "",
            Name: "",
            Type: "BANK",
            BankAccountNumber: "",
            CurrencyCode: currencies?.[0]?.Code || null,
            BankAccountType: "BANK",
          });
          setIsOpen(true);
        }}
      >
        <span className="fa fa-plus mr-2" />
        <Trans>Add Bank Account</Trans>
      </Button>
    </div>
    {isOpen ? (
      <Modal size="lg">
        <EditAccount
          currencies={currencies}
          onSuccess={onSuccess}
          accountTypes={accountTypes}
          taxRates={taxRates}
          toggle={toggle}
          values={editing}
        />
      </Modal>
    ) : null}
    {data.loading ? <LoadingMsg/>:
    <TableContainer
      items={filteredResults}
      ordering={ordering}
      onOrderingChanged={setOrdering}
      selected={selected}
      onSelectedChanged={setSelected}
    >
      <Table responsive>
        <thead>
          <tr>
            <th className="text-nowrap text-left">
              <Trans>Account Name</Trans>
            </th>
            <th className="text-nowrap">
              <Trans>Account Number</Trans>
            </th>
            <th className="text-nowrap">
              <Trans>Currency</Trans>
            </th>
            {/* <th /> */}
          </tr>
        </thead>
        <tbody>
          {filteredResults.map((i) => (
            <tr key={i.AccountID}>
              <td className="text-nowrap text-left">
                <Link to={`${match.url}/${i.AccountID}/bank_transactions`}>
                  {i.Name}
                </Link>
              </td>
              <td className="text-nowrap">{i.BankAccountNumber}</td>
              <td className="text-nowrap"><CurrencySymbol currency={i.CurrencyCode} /></td>
              {/* <td className="text-end">
                <Link to={`/reports/bank_statement/${i.AccountID}`}>
                  <Trans>Statement</Trans>
                </Link>
              </td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>}
    {!data.loading && filteredResults.length === 0 && <p className="text-center"><Trans>No results found</Trans></p>}
    <XeroTableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      limit={limit}
      url={url}
      filters={filters}
      offset={offset}
      onDataFetched={setData}
    />
  </Page>
)};

const enhance = compose(withTable({ limit: 999999 }));

export default enhance(OrganisationList);
